var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardNumberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.873,
    height: 23.121,
    viewBox: "0 0 35.873 23.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cvv",
    transform: "translate(0 -91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11743",
    "data-name": "Path 11743",
    d: "M0,250.459a3.156,3.156,0,0,0,3.153,3.153H32.72a3.156,3.156,0,0,0,3.153-3.153V241H0ZM4.9,245.2H21.86v2.1H4.9Z",
    transform: "translate(0 -139.49)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11744",
    "data-name": "Path 11744",
    d: "M32.72,91H3.153A3.156,3.156,0,0,0,0,94.153V95.2H35.873V94.153A3.156,3.156,0,0,0,32.72,91Z",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11745",
    "data-name": "Path 11745",
    d: "M0,181H35.873v2.1H0Z",
    transform: "translate(0 -83.694)",
    fill: "#df9426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardNumberIcon);
export default __webpack_public_path__ + "static/media/card_number_icon.251f7f05e10e1246c7418832b73055f7.svg";
export { ForwardRef as ReactComponent };